module.exports = __webpack_public_path__ + "static/media/SarahSwitek_03_HowAreYouFeeling-Confirmation_10.c38ce3dd.mp3";